import styled from "styled-components";
import { CssRule } from "../../../../../themes/architecture/css-helpers/css-rule";
import { styledByTheme } from "../../../../../themes/architecture/styled-by-theme";

const SideMenuLinkIconDefaultWrapBase = styled.div`
    display: block;
    width: 24px;
    height: 24px;
    margin: 0 1rem 0 0;
    border-radius: 50%;

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        margin: 0 2rem 0 0;
    }

    ${CssRule.For.RTL.build()} & {
        margin: 0 0 0 1rem;
    }
`;

const SideMenuLinkIconCasino777WrapBase = styled(SideMenuLinkIconDefaultWrapBase)`
    border-radius: 0;
`;

export const SideMenuLinkIconWrapBase = styledByTheme(SideMenuLinkIconDefaultWrapBase)
    .forCasino777(SideMenuLinkIconCasino777WrapBase)
    .apply();
